import { createSlice } from "@reduxjs/toolkit";
import teleradiologistAuditLogsApi from "../../../rtk-apis/audit/teleradiologistAuditLogs";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const teleradiologistAuditLogsSlice = createSlice({
  name: "teleradiologistAuditLogsSlice",
  initialState,
  reducers: {
    clearBillingAuditState: (state) => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
      state.error = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(teleradiologistAuditLogsApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(teleradiologistAuditLogsApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload;
        state.msg = payload.msg;
      })
      .addCase(teleradiologistAuditLogsApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export const { clearBillingAuditState } = teleradiologistAuditLogsSlice.actions;
export default teleradiologistAuditLogsSlice.reducer;
